import React, { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { useStore } from '@/store/zustand-solicitud';
import { Progress } from 'antd';
import './styles/dashboardNavbar.scss';

const DashboardNavbar: React.FC = () => {
  const { getSteps, navbarVisible, progress, setProgress } = useStore();
  const nSteps = getSteps();
  const fullPath = usePathname();
  const paths = fullPath.split('/');
  const stepActual = paths[paths.length - 1];

  useEffect(() => {
    if (nSteps.length > 0 && stepActual) {
      const currentIndex = nSteps.findIndex((item: any) => item.url === '/' + stepActual);
      if (currentIndex !== -1) {
        const calculatedProgress = ((currentIndex + 1) / nSteps.length) * 100;

        // Evita llamar setProgress si no cambió
        if (progress !== calculatedProgress) {
          setProgress(calculatedProgress);
        }
      }
    }
  }, [stepActual, nSteps, progress, setProgress]);

  return (
    <div className="dashboard-navbar">
      {navbarVisible && (
        <div className="progress-container">
          <div className="progress-wrapper">
            <Progress
              percent={progress}
              status="normal"
              showInfo={false}
              strokeColor={{
                '0%': 'var(--light-primary-color)', // Color más claro desde la variable global
                '100%': 'var(--primary-color)', // Color base desde la variable global
              }}
              trailColor="#e0e0e0" // Fondo de la barra
            />
            {/* Punto indicador */}
            <div
              className="progress-indicator"
              style={{
                left: `calc(${progress}% - 8px)`, // Posición horizontal del punto
                top: '50%', // Centra el punto verticalmente en el wrapper
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default DashboardNavbar;
